/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import '@nib-group/design-tokens/common/tokens.css';
import '@nib-group/design-tokens/brand/nib/tokens.default.css';
import { TealiumProvider } from '@nib-group/tealium-universal-tag/react';
import { tealiumConfig } from './src/metrics/config';

export const wrapRootElement = ({ element }) => (
  <TealiumProvider {...tealiumConfig}>{element}</TealiumProvider>
);
